import React from 'react';
import { Animation } from '../../assets/global/globalStyles';
import FormWarehouse from '../../components/Forms/FormWarehouse';

export default function CreateWarehouse() {
  return (
    <Animation>
      <FormWarehouse />
    </Animation>
  );
}
